import { render } from "./CautionInfo.vue?vue&type=template&id=4432fe12"
import script from "./CautionInfo.vue?vue&type=script&lang=js"
export * from "./CautionInfo.vue?vue&type=script&lang=js"

import "./CautionInfo.vue?vue&type=style&index=0&id=4432fe12&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__